import {
  buildAnalyticsPageLocation,
  resolveAnalyticsPagePath,
} from './routes';

export const ANALYTICS_PAGE_TITLE = 'Bundle Drop';

export type AnalyticsPageContext = {
  page_path: string;
  page_location: string;
  page_title: string;
  page_referrer: string;
};

const getSafePagePath = (locationValue: string): string =>
  resolveAnalyticsPagePath(locationValue) ?? '/';

const getSafeReferrer = (referrer: string, currentOrigin: string): string => {
  if (!referrer) {
    return '';
  }

  try {
    const referrerUrl = new URL(referrer);
    if (referrerUrl.origin !== currentOrigin) {
      return referrerUrl.origin;
    }

    const pagePath = getSafePagePath(referrerUrl.pathname);
    return buildAnalyticsPageLocation(pagePath, currentOrigin);
  } catch {
    return '';
  }
};

export const getAnalyticsPageContext = ({
  pathname,
  origin,
  referrer,
}: {
  pathname: string;
  origin: string;
  referrer: string;
}): AnalyticsPageContext => {
  const pagePath = getSafePagePath(pathname);

  return {
    page_path: pagePath,
    page_location: buildAnalyticsPageLocation(pagePath, origin),
    page_title: ANALYTICS_PAGE_TITLE,
    page_referrer: getSafeReferrer(referrer, origin),
  };
};

export const getCurrentAnalyticsPageContext = (): AnalyticsPageContext => {
  if (typeof window === 'undefined') {
    return {
      page_path: '/',
      page_location: '/',
      page_title: ANALYTICS_PAGE_TITLE,
      page_referrer: '',
    };
  }

  return getAnalyticsPageContext({
    pathname: window.location.pathname,
    origin: window.location.origin,
    referrer: document.referrer,
  });
};
